import React, { useCallback, useContext, useEffect } from "react";

import { Model } from 'survey-core';
import { Survey as SurveyUI } from 'survey-react-ui';

import './Login.css';

import { useNavigate, useOutletContext } from "react-router-dom";
import { OutletContextModel } from "../../models/OutletContextModel";
import { AuthContext } from "../../core/context/authContext";

// const errorText = 'Debe ingresar'
const passwordRegex = /^[a-zA-Z0-9 = \- ^;:!#$%&()*+/=?@_.]{6,25}$/;

const formJson = {
    title: 'Inicio de sesión',
    showQuestionNumbers: 'none',
    checkErrorsMode: 'onValueChanged',
    completeText: 'Ingresar',
    showCompletedPage: false,
    elements: [
        {
            defaultValue: '',
            type: 'text',
            name: 'email',
            title: 'Correo electrónico',
            placeholder: 'Ingresar correo electrónico',
            isRequired: true,
            requiredErrorText: 'Campo requerido',
            validators: [
                {
                    type: 'email',
                    text: 'Ingresar correo electrónico válido'
                }
            ]
        },
        {
            defaultValue: '',
            type: 'text',
            inputType: 'password',
            name: 'password',
            title: 'Contraseña',
            placeholder: 'Ingresar contraseña',
            isRequired: true,
            requiredErrorText: 'Campo requerido',
            validators: [
                {
                    type: 'regex',
                    regex: passwordRegex,
                    text: 'Ingresar contraseña con al menos 6 caracteres'
                }
            ]
        }
    ]
};

const loggedInRoute = '/historial-encuestas';

const Login = () => {
    const survey = new Model(formJson);

    const outletContext: OutletContextModel = useOutletContext();
    const navigate = useNavigate();

    const { handleLoginWithCredentials } = useContext(AuthContext);

    const authenticatedStatus = 'authenticated';
    const { status } = useContext(AuthContext);

    useEffect(() => {
        if (status === authenticatedStatus) {
            navigate(loggedInRoute, { replace: true });
        }
    }, [status, navigate]);

    survey.applyTheme(outletContext.theme);
    survey.onComplete.add(
        useCallback(async (sender: Model) => {
            const results = sender.data

            const succesful = await handleLoginWithCredentials(results.password, results.email);
            if (succesful) {
                navigate(loggedInRoute, { replace: true });
            }
        }, [handleLoginWithCredentials, navigate])
    );

    return (
        <div className="full-height-container ">
            <SurveyUI model={survey} />
        </div>
    )
}

export default Login;